import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';
import BirthDatePickerField from '../../../../BaseModule/Components/Form/Components/BirthDatePicker/BirthDatePickerField';
import DatePickerField from '../../../../BaseModule/Components/Form/Components/DatePicker/DatePickerField';
import { WizardItemRuleType } from '../../../Enums/WizardItemRuleType.enum';
import moment from 'moment';

interface Props {
	item: Extract<
		WizardItem,
		{ type: WizardItemType.DATE | WizardItemType.DATE_PICKER }
	>;
}

const WizardDate: React.FC<Props> = ({ item }) => {
	const rules = item.settings?.rules;

	const minDateRule = rules?.find(
		rule => rule.type === WizardItemRuleType.MIN_DATE,
	);
	const maxDateRule = rules?.find(
		rule => rule.type === WizardItemRuleType.MAX_DATE,
	);

	if (item.subtype === WizardItemSubType.BIRTH_DATE) {
		return (
			<BirthDatePickerField
				name={item.key}
				label={item.title}
				isRequired={item.settings?.required}
				minDate={minDateRule && moment(minDateRule.value)}
				maxDate={maxDateRule && moment(maxDateRule.value)}
				isWrapped
			/>
		);
	}

	return (
		<DatePickerField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
			minDate={minDateRule && moment(minDateRule.value)}
			maxDate={maxDateRule && moment(maxDateRule.value)}
			isWrapped
		/>
	);
};

export default WizardDate;
